import { render } from "./FormSubtitle.vue?vue&type=template&id=13f72c8c&scoped=true"
import script from "./FormSubtitle.vue?vue&type=script&lang=js"
export * from "./FormSubtitle.vue?vue&type=script&lang=js"

import "./FormSubtitle.vue?vue&type=style&index=0&id=13f72c8c&lang=scss&scoped=true"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13f72c8c"]])

export default __exports__